<template>
  <div class="p-[20px] border border-solid border-steam rounded-[8px] overflow-visible vs-con-loading__container" id="order-section-loading">
    <div class="flex justify-between">
      <div class="flex flex-wrap gap-[4px] items-center lg:justify-center">
        <div class="flex gap-[4px]">
          <shipblu-icon iconLibrary="feather" iconName="PackageIcon" iconClass="text-industrial-revolution text-[18px]"/>
          <p class="text-lg text-young-night">{{ $t('Order') }}</p>
        </div>
        <div v-if="orderData.is_exchange">
          <p class="text-base text-darkgray font-medium leading-tight">
            ({{ common.defineOrderType(orderData) === 'delivery-orders' ? $t('Linked Return Order') : $t('Linked Delivery Order') }}
            <router-link :to="common.defineOrderType(orderData) === 'returns' ? `/${$i18n.locale}/${$store.state.AppActiveUser.userRole}/orders/delivery-orders?order=${orderData && orderData.linked_exchange_order ? orderData.linked_exchange_order.delivery_order.id : ''}` : `/${$i18n.locale}/${$store.state.AppActiveUser.userRole}/orders/returns?order=${orderData && orderData.linked_exchange_order ? orderData.linked_exchange_order.return_order.id : ''}`">
              <span class="text-primary underline font-semibold cursor-pointer">{{ common.defineOrderType(orderData) === 'delivery-orders' ? orderData.linked_exchange_order.return_order.tracking_number : orderData.linked_exchange_order.delivery_order.tracking_number }}</span>
            </router-link>)
          </p>
        </div>
      </div>
      <div v-if="$store.state.AppActiveUser.userRole === 'merchant' && merchantStatus === 'active' && ((common.defineOrderType(orderData) === 'returns' && common.getPermissions('return_orders', 'base', 'update')) || (common.defineOrderType(orderData) === 'delivery-orders' && common.getPermissions('delivery_orders', 'base', 'update')))">
        <div class="flex" v-if="orderData.status === 'created' || orderData.status === 'return_requested' || orderData.status === 'pickup_requested' || (orderData.status === 'out_for_pickup' && common.defineOrderType(orderData) === 'delivery-orders')">
          <feather-icon icon="EditIcon" svgClasses="h-5 w-5" class="text-silver cursor-pointer" v-if="!editable" @click="editInformation()"/>
        </div>
      </div>
      <div class="flex" v-else-if="$store.state.AppActiveUser.userRole === 'admin' || $store.state.AppActiveUser.userRole === 'customer-support'">
        <feather-icon icon="EditIcon" svgClasses="h-5 w-5" class="text-silver cursor-pointer" 
          v-if="!editable && !(orderData.status === 'delivered' || orderData.status === 'returned' || orderData.status === 'returned_to_origin' || orderData.status === 'cancelled')" @click="editInformation()" />
      </div>
    </div>
    <div class="mt-6 grid grid-cols-2 gap-x-4 gap-y-6 relative">
      <div class="mb-4" v-if="$store.state.AppActiveUser.userRole !== 'merchant'">
        <div class="flex items-center gap-x-2">
          <p class="text-young-night sm:text-[14px] text-[12px] leading-tight">{{ $t('Merchant Name') }}</p>
        </div>
        <router-link class="text-primary sm:text-[14px] text-[12px]" target="_blank" :to="{ name: `${$store.state.AppActiveUser.userRole}-merchant-view`, params: {tab: 'info', merchantID: orderData.merchant.id } }" v-if="$store.state.AppActiveUser.userRole === 'admin' || $store.state.AppActiveUser.userRole === 'sales' || $store.state.AppActiveUser.userRole === 'customer-support' || $store.state.AppActiveUser.userRole === 'finance'">
          {{ orderData.merchant ? orderData.dba ? orderData.dba + ' - ' + orderData.merchant.name : orderData.merchant.name : 'N/A' }} {{ orderData.merchant.display_name ?  '- ' +  orderData.merchant.display_name : '' }}
        </router-link>
        <p v-else class="text-industrial-revolution">{{ orderData.merchant ? orderData.dba ? orderData.dba + ' - ' + orderData.merchant.name : orderData.merchant.name : 'N/A' }} {{ orderData.merchant.display_name ?  '- ' +  orderData.merchant.display_name : '' }}</p>
      </div>
      <div>
        <div v-if="!editable">
          <p class="mb-1 sm:text-[14px] text-[12px] text-young-night">{{ $t('Handling Method') }}</p>
          <p class="sm:text-[14px] text-[12px] text-industrial-revolution" >{{ selectedDropoffOption.name }}</p>
        </div>
        <shipblu-select :key="handlingMethodKey" inputId="handling-method" v-show="editable" v-validate="selectedDropoffOption === null" :localize="true" :inputValue="selectedDropoffOption" :options="CounterDropoffOptions" optionLabel="name"
          :disabled="outForPickupEdit()" :labelPlaceholder="$t('Handling Method')" name="dropoff" @selectedOptions="selectdropoffOptions($event[0])"/>
        <p class="text-danger sm:text-[14px] text-[12px]" v-show="errors.has('dropoff')">{{ $t('Handling Method field is required') }}</p>
      </div>
      <div>
        <p class="mb-1 sm:text-[14px] text-[12px] text-young-night" v-show="!editable">{{ $t('Reference Number') }}</p>
        <p v-show="!editable || localStorage.getItem('multipleWarehouses') !== 'true'" class="sm:text-[14px] text-[12px] text-industrial-revolution">{{ orderData.merchant_order_reference ? orderData.merchant_order_reference : 'N/A' }}</p>
        <div v-show="editable && localStorage.getItem('multipleWarehouses') === 'true'">
          <shipblu-input :disabled="outForPickupEdit()" inputId="merchant-order-reference" autocomplete="nofill" v-validate="'max:30'" name="merchant order reference" v-model="orderData.merchant_order_reference" type="text" :labelPlaceholder="$t('Reference Number')" class="w-full"/>
          <span class="text-danger sm:text-[14px] text-[12px]" v-show="errors.has('merchant order reference')">{{ errors.first('merchant order reference') }}</span>
        </div>
      </div>
      <div v-if="common.defineOrderType(orderData) !== 'cash-collections'">
        <p class="text-young-night sm:text-[14px] text-[12px] leading-tight" v-show="!editable">{{ $t('Pickup Date') }}</p>
        <p class="text-industrial-revolution sm:text-[14px] text-[12px] mt-1" v-show="!editable">{{ orderData.pickup_date ? new Date(orderData.pickup_date).toLocaleDateString('fr-CA') : 'N/A' }}</p>
        <div v-show="editable">
          <shipblu-input inputId="pickup-date" :disabled="true" autocomplete="nofill" v-model="orderData.pickup_date" type="text" :labelPlaceholder="$t('Pickup Date')" class="w-full"/>
        </div>
      </div>
      <div v-show="common.defineOrderType(orderData) !== 'cash-collections' && common.defineOrderType(orderData) !== 'returns' && selectedDropoffOption.value !== true">
        <p v-show="!editable" class="mb-1 sm:text-[14px] text-[12px] text-young-night">{{ $t('Pickup Point') }}</p>
        <p v-show="!editable" class="sm:text-[14px] text-[12px] text-industrial-revolution mt-1">{{ orderData.pickup_point && orderData.pickup_point.address ? orderData.pickup_point.address.line_1 + orderData.pickup_point.address.line_2 + orderData.pickup_point.address.zone.name : '' }}</p>
        <div v-show="editable">
          <shipblu-select inputId="pickup-point" v-show="editable" :localize="true"
            :key="pickupPointKey" :inputValue="inputPickupValue" :options="pickupPoints" optionLabel="fullAddress" :disabled="outForPickupEdit()"
            :labelPlaceholder="$t('Pickup Point')" name="pickup point" @selectedOptions="selectPickupPointOptions($event[0])"/>
          <span class="text-danger sm:text-[14px] text-[12px]" v-show="errors.has('pickup point')">{{ errors.first('pickup point') }}</span>
        </div>
      </div>
      <div v-if="common.defineOrderType(orderData) === 'returns' || common.defineOrderType(orderData) === 'delivery-orders'">
        <p v-show="!editable" class="mb-1 sm:text-[14px] text-[12px] text-young-night">{{ $t('Return Point') }}</p>
        <p v-show="!editable" class="sm:text-[14px] text-[12px] text-industrial-revolution mt-1">{{ orderData.return_point && orderData.return_point.address ? orderData.return_point.address.line_1 + orderData.return_point.address.line_2 + orderData.return_point.address.zone.name : '' }}</p>
        <div v-show="editable">
          <shipblu-select inputId="return-point" v-show="editable" :key="returnPointKey" :localize="true" :inputValue="inputReturnValue && inputReturnValue" :options="returnPoints" optionLabel="fullAddress"
            :labelPlaceholder="$t('Return Point')" name="return point" @selectedOptions="selectReturnPointOptions($event[0])" :disabled="outForPickupEdit()"/>
        </div>
      </div>
      <div v-if="common.defineOrderType(orderData) !== 'cash-collections' && $store.state.AppActiveUser.userRole !== 'head-of-fleet' && $store.state.AppActiveUser.userRole !== 'manager' && ((common.defineOrderType(orderData) === 'returns' && common.getPermissions('return_orders', 'cash_amount', 'view')) || (common.defineOrderType(orderData) === 'delivery-orders' && common.getPermissions('delivery_orders', 'cash_amount', 'view')))">
        <div class="flex items-center gap-x-2">
          <p v-if="!editable" class="flex">
            <span v-show="!editable" class="sm:text-[14px] text-[12px] text-young-night">{{ common.defineOrderType(orderData) === 'delivery-orders' ? $t('Cash Amount') : $t('Cash Refund') }}</span>
            <span v-if="$store.state.AppActiveUser.userRole === 'customer-support'">
              <span v-if="orderData.is_paid && orderData.payment_method === null" class="material-symbols-outlined text-2xl">credit_card</span>
              <img v-else class="ml-2 w-6" :src="payType" alt="">
            </span>
          </p>
          <span v-if="orderData.is_paid && $store.state.AppActiveUser.userRole !== 'customer-support'" class="material-symbols-outlined text-2xl">credit_card</span>
        </div>
        <p v-show="!editable || localStorage.getItem('multipleWarehouses') !== 'true'" class="sm:text-[14px] text-[12px] text-industrial-revolution font-medium">
          {{ orderData.cash_amount && parseInt(orderData.cash_amount) > 0 && !editable ? (((orderData.cash_amount).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) + ' ' + $t('EGP') : 'N/A' }}
        </p>
        <div v-show="editable && localStorage.getItem('multipleWarehouses') === 'true'">
          <shipblu-input :disabled="(common.defineOrderType(orderData) === 'returns' && !common.getPermissions('return_orders', 'cash_amount', 'update')) || (common.defineOrderType(orderData) === 'delivery-orders' && !common.getPermissions('delivery_orders', 'cash_amount', 'update'))" inputId="cash-amount" autocomplete="nofill" v-validate="'required|decimal'" name="amount" v-model="orderData.cash_amount" type="text" :labelPlaceholder="common.defineOrderType(orderData) === 'delivery-orders' ? $t('Cash Amount') : $t('Cash Refund')" class="w-full"/>
          <p class="text-danger sm:text-[14px] text-[12px]" v-show="errors.has('amount')">{{ errors.first('amount') }}</p>
        </div>
      </div>
      <div v-if="common.defineOrderType(orderData) !== 'cash-collections'">
        <div class="flex items-center gap-x-2" v-if="!editable || localStorage.getItem('multipleWarehouses') !== 'true'">
          <p class="sm:text-[14px] text-[12px] text-young-night">{{ $t('Product declared value') }}</p>
        </div>
        <p v-show="!editable || localStorage.getItem('multipleWarehouses') !== 'true'" class="sm:text-[14px] text-[12px]  text-industrial-revolution">
          {{ orderData.declared_value && parseInt(orderData.declared_value) > 0 && !editable ? ((orderData.declared_value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ' ' + $t('EGP') : 'N/A' }}
        </p>
        <div v-show="editable && localStorage.getItem('multipleWarehouses') === 'true'">
          <div>
            <shipblu-input :disabled="$store.state.AppActiveUser.userRole !== 'merchant' || outForPickupEdit()" inputId="declared-value" autocomplete="nofill" v-validate="'decimal'" name="declared value" v-model="orderData.declared_value" type="text" :labelPlaceholder="$t('Product declared value')" class="w-full"/>
            <p class="text-danger sm:text-[14px] text-[12px]" v-show="errors.has('declared value')">{{ errors.first('declared value') }}</p>
          </div>
        </div>
      </div>
      <div>
        <p class="sm:text-[14px] text-[12px] text-young-night" v-show="!editable">{{ common.defineOrderType(orderData) === 'returns' ? $t('Preferred Pickup Date') : $t('Preferred Delivery Date') }}</p>
        <p v-show="!editable" class="sm:text-[14px] text-[12px] text-industrial-revolution mt-1">{{ orderData.preferred_date ? orderData.preferred_date : 'N/A' }}</p>
        <div v-if="editable">
          <div v-if="orderData.visit_dates && orderData.visit_dates.length && orderData.visit_dates.length > 0 && $store.state.AppActiveUser.userRole === 'customer-support'" v-show="editable">
            <datepicker name="date" :disabledDates="disabledDates" :placeholder="common.defineOrderType(orderData) === 'returns' ? $t('Preferred Pickup Date') : $t('Preferred Delivery Date')" v-model="orderData.preferred_date" class="w-full h-full order-date-picker"></datepicker>
            <span class="text-danger text-sm" v-show="errors.has('date')">{{ errors.first('date') }}</span>
          </div>
          <shipblu-input v-else inputId="preferred-date" :disabled="true" autocomplete="nofill" v-model="orderData.preferred_date" type="text" :labelPlaceholder="common.defineOrderType(orderData) === 'returns' ? $t('Preferred Pickup Date') : $t('Preferred Delivery Date')" class="w-full"/>
        </div>
      </div>
      <div v-if="common.defineOrderType(orderData) !== 'cash-collections'">
        <p class="text-young-night sm:text-[14px] text-[12px]" v-if="!editable">{{ common.defineOrderType(orderData) === 'returns' ? $t('Last Date for Pickup') : $t('Last Date for Delivery') }}</p>
        <p class="text-industrial-revolution mt-1 sm:text-[14px] text-[12px]"  v-if="!editable">{{ orderData.last_visit_date ? orderData.last_visit_date : 'N/A' }}</p>
        <shipblu-input inputId="last-date-date" v-if="editable" :disabled="true" autocomplete="nofill" v-model="orderData.last_visit_date" type="text" :labelPlaceholder="common.defineOrderType(orderData) === 'returns' ? $t('Last Date for Pickup') : $t('Last Date for Delivery')" class="w-full"/>
      </div>
    </div>
    <div v-if="$store.state.AppActiveUser.userRole === 'merchant'">
      <div class="grid grid-cols-2 gap-4" v-if="orderData.status === 'created'|| orderData.status === 'pickup_requested' || orderData.status === 'return_requested'">
        <shipblu-button class="mt-6 font-semibold" v-if="editable" @click="updateOrderInfo()" :textButton="$t('Save')"/>
        <shipblu-button class="mt-6 font-semibold" v-if="editable" @click="cancelOrderInformationEdit()" color="secondary" :textButton="$t('Cancel')"/>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-4" v-else-if="$store.state.AppActiveUser.userRole === 'admin' || $store.state.AppActiveUser.userRole === 'head-of-fleet' || $store.state.AppActiveUser.userRole === 'customer-support'">
      <shipblu-button class="mt-6 font-semibold" v-if="editable" @click="updateOrderInfo()" :textButton="$t('Save')"/>
      <shipblu-button class="mt-6 font-semibold" v-if="editable" @click="cancelOrderInformationEdit()" color="secondary" :textButton="$t('Cancel')"/>
    </div>
  </div>
</template>

<script>
import ShipbluCard from '@/layouts/components/ShipbluCard.vue'
import { sendRequest } from '../../../http/axios/requestHelper'
import vSelect from 'vue-select'
import i18nData from '../../../i18n/i18nData'
import common from '../../../assets/utils/common'
import Datepicker from 'vuejs-datepicker'
import cod from '../../../assets/images/pages/cash.svg'
import epayment_cards from '../../../assets/images/pages/visa.svg'
import flash from '../../../assets/images/pages/flash-pay.svg'
import valu from '../../../assets/images/pages/valu.svg'

export default {
  props: ['orderData', 'insurance', 'merchantStatus'],
  data () {
    return {
      common,
      localStorage,
      editable: false,
      returnPoints: [],
      pickupPoints: [],
      disabledDates: {
        days: [5]
      },
      payType: '',
      CounterDropoffOptions:[
        {
          id: 1,
          name: 'DROPOFF',
          value: true
        },
        {
          id: 2,
          name: 'PICKUP',
          value: false
        }
      ],
      selectedReturnPointOption: {},
      inputReturnValue: null,
      inputPickupValue: null,
      pickupPointKey: 0,
      returnPointKey: 0,
      handlingMethodKey: 0
    }
  },
  computed: {
    selectedDropoffOption () {
      return this.orderData.is_counter_dropoff ? {
        id: 1,
        name: i18nData[this.$i18n.locale]['DROPOFF'],
        value: true
      } : {
        id: 2,
        name: i18nData[this.$i18n.locale]['PICKUP'],
        value: false
      }
    }
  },
  watch: {
    'editable' (val) {
      if (val) {
        this.handlingMethodKey += 1
        this.disabledDates.customPredictor = (date) => {
          if (!this.orderData.visit_dates.includes(date.toISOString().split('T')[0])) {
            return true
          }
        }
      
      }
    },
    'orderData' () {
      this.$validator.resume()
      this.orderData.cash = this.orderData.cash_amount
      this.editable = false
      this.payTypeImg()
      if (this.orderData.merchant.id) {
        this.loadPickupPoints(this.orderData.merchant.id)
        this.loadReturnPoints(this.orderData.merchant.id)
      }
    }
  },
  mounted () {
    if (this.orderData.pickup_date) this.orderData.pickup_date = this.formatDate(this.orderData.pickup_date)
    if (this.orderData.preferred_date) this.orderData.preferred_date = this.formatDate(this.orderData.preferred_date)
  },
  methods: {
    selectdropoffOptions (data) {
      this.orderData.is_counter_dropoff = data.value
    },
    selectPickupPointOptions (data) {
      this.orderData.pickup_point = data
    },
    selectReturnPointOptions (data) {
      this.orderData.return_point = data
    },
    formatDate (date) {
      if (!date) return ''
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      return new Date(date).toLocaleDateString('en-US', options)
    },
    payTypeImg () {
      switch (this.orderData.payment_method) {
      case 'cod':
        this.payType = cod
        break
      case 'upg':
        this.payType = epayment_cards
        break
      case 'epayment_cards':
        this.payType = epayment_cards
        break
      case 'flash':
        this.payType = flash
        break
      case 'valu':
        this.payType = valu
        break
      default:
        this.payType = ''
      }
    },
    getOrderStatusColor (order) {
      return common.getOrderStatusColor(this.getStatusLabel(order))
    },
    getStatusLabel (order) {
      return common.getStatusLabel(order.status ? order : order.status, this.$store.state.AppActiveUser.userRole)
    },
    editInformation () {
      this.editable = true
      if (common.defineOrderType(this.orderData) !== 'cash-collections') {
        const pickupPointObj = this.pickupPoints.find((item) => item.id === this.orderData.pickup_point.id)
        this.inputPickupValue = {
          id: pickupPointObj && pickupPointObj.id,
          fullAddress: pickupPointObj.address.line_1 + pickupPointObj.address.line_2 + pickupPointObj.address.zone.name 
        }
        this.pickupPointKey += 1
        const returnPointObj = this.returnPoints.find((item) => item.id === this.orderData.return_point.id)
        this.inputReturnValue = {
          id: returnPointObj && returnPointObj.id,
          fullAddress: returnPointObj && returnPointObj.address ? returnPointObj.address.line_1 + returnPointObj.address.line_2 + returnPointObj.address.zone.name : ''
        }
        this.returnPointKey += 1
      }
    },
    loadPickupPoints (merchantID) {
      sendRequest(true, false, this, `api/v1/merchants/${merchantID}/pickup-points/`, 'get', null, true, 
        (response) => {
          this.pickupPoints = response.data.results
          this.pickupPoints.forEach(element => {
            element.fullAddress = element.address.line_1 + element.address.line_2 + element.address.zone.name
          })
        }
      )
    },
    async loadReturnPoints (merchantID) {
      sendRequest(true, false, this, `api/v1/merchants/${merchantID}/return-points/`, 'get', null, true, 
        (response) => {
          this.returnPoints = response.data.results
          this.returnPoints.forEach(element => {
            element.fullAddress = element.address.line_1 + element.address.line_2 + element.address.zone.name
          })
        }
      )
    },
    updateOrderInfo () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading({
            background: this.backgroundLoading,
            color: this.colorLoading,
            container: '#order-section-loading',
            scale: 0.45
          })
          let orderObj = {}
          if (common.defineOrderType(this.orderData) === 'cash-collections') {
            orderObj = {
              amount: this.orderData.amount
            }
          } else {
            orderObj = {
              merchant_order_reference: this.orderData.merchant_order_reference,
              is_counter_dropoff: this.orderData.is_counter_dropoff,
              declared_value: Number(this.orderData.declared_value),
              preferred_date: this.orderData.preferred_date ? String(this.orderData.preferred_date).includes('T') ? this.orderData.preferred_date.toISOString().split('T')[0] : this.orderData.preferred_date : null
            }
            if (Number(this.orderData.cash_amount) !== Number(this.orderData.cash)) orderObj.cash_amount = Number(this.orderData.cash_amount)
            if (this.orderData.return_point) orderObj.return_point = this.orderData.return_point.id
            if (this.orderData.pickup_point) orderObj.pickup_point = this.orderData.pickup_point.id
          }
          sendRequest(true, false, this, `api/v1/${common.defineOrderType(this.orderData)}/${this.$route.query.order}/`, 'patch', orderObj, true,
            () => {
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:i18nData[this.$i18n.locale]['Delivery Order'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
                position: 'top-center'
              })
              this.cancelOrderInformationEdit()
              this.$vs.loading.close('#order-section-loading > .con-vs-loading')
            },
            (error) => {
              common.notifyResponseError(this, error)
              this.$vs.loading.close('#order-section-loading > .con-vs-loading')
              this.$emit('loadOrder', 'orderInfoCardLoading')
            }
          )
        }
      })
    },
    cancelOrderInformationEdit () {
      this.editable = !this.editable
      this.$validator.pause()
      this.$emit('loadOrder')
    },
    outForPickupEdit () {
      return this.orderData.status === 'out_for_pickup' && this.$store.state.AppActiveUser.userRole === 'merchant'
    }
  },
  components: {
    ShipbluCard,
    vSelect,
    Datepicker
  }
}
</script>

<style lang="scss">
.order-date-picker {
  input {
    height: 48px;
  }
}
</style>